export const all_routes = {
  home: '/',
  liveTeaching: '/live',
  liveTeachingWithCategory: '/live/kategori/:category',
  jadiCourse: '/e-course',
  jadiCourseWithCategory: '/e-course/kategori/:category',
  jadiUkom: '/ukom',
  jadiUkomWithCategory: '/ukom/kategori/:category',
  jadiCourseDetail: '/e-course/detail/:id',
  liveTeachingDetail: '/live/detail/:id',
  jadiUkomDetail: '/ukom/detail/:id',

  // Order
  orderStatus: '/order-status',

  program: '/program',

  // Admin
  adminDashboard: '/admin/dashboard',

  adminUser: '/admin/user',
  adminUserCreate: '/admin/user/add',
  adminUserDetail: '/admin/user/:id',
  adminUserEdit: '/admin/user/edit/:id',

  adminTransaction: '/admin/transaction',

  adminLiveTeaching: '/admin/live-teaching',
  adminEditLiveTeaching: '/admin/live-teaching/:id',
  adminDetailLiveTeaching: '/admin/live-teaching/detail/:id',
  adminAddLiveTeaching: '/admin/live-teaching/create',

  adminCourses: '/admin/courses',
  adminDetailCourse: '/admin/courses/detail/:id',
  adminEditCourse: '/admin/courses/:id',
  adminAddCourse: '/admin/courses/create',
  adminCourseAnalytics: '/admin/courses/analytics/:id',
  adminCertificates: '/admin/certificates',
  adminCertificatePreview: '/admin/certificates/:certificateNumber',

  adminCBT: '/admin/cbt',
  adminEditCBT: '/admin/cbt/:id',
  adminAddCBT: '/admin/cbt/create',

  adminPromoCode: '/admin/promo-code',

  adminPages: '/admin/pages',
  adminSettingPassword: '/admin/settings',
  adminSettingMenu: '/admin/settings/main-menu',
  adminSettingSubMenu: '/admin/settings/sub-menu/:id',

  //students
  userDashboard: '/user/dashboard',

  //Home Modules
  homeone: '/',
  hometwo: '/index-2',
  homethree: '/index-3',
  homefour: '/index-4',
  homefive: '/index-5',
  homesix: '/index-6',

  //Course Modules
  courseGrid: '/course/course-grid',
  courseList: '/course/course-list',
  courseDetails: '/course/course-details',
  courseDetails2: '/course/course-details-2',
  courseCategory: '/course/course-category',
  courseCategory2: '/course/course-category-2',
  courseCategory3: '/course/course-category-3',
  courseResume: '/course/course-resume',
  courseWatch: '/course/course-watch',
  courseCart: '/course/cart',
  courseCheckout: '/course/checkout',
  addNewCourse: '/course/add-course',

  //Instructor Modules
  instructorDashboard: '/instructor/instructor-dashboard',
  instructorProfile: '/instructor/instructor-profile',
  instructorCourse: '/instructor/instructor-course',
  instructorCourseGrid: '/instructor/instructor-course-grid',
  instructorAnnouncements: '/instructor/instructor-announcements',
  instructorAssignment: '/instructor/instructor-assignment',
  instructorQuiz: '/instructor/instructor-quiz',
  instructorQuizResult: '/instructor/instructor-quiz-results',
  instructorCertificate: '/instructor/instructor-certificate',
  instructorEarning: '/instructor/instructor-earnings',
  instructorPayout: '/instructor/instructor-payout',
  instructorStatements: '/instructor/instructor-statements',
  instructorMessage: '/instructor/instructor-message',
  instructorTickets: '/instructor/instructor-tickets',
  instructorChangePassword: '/instructor/instructor-change-password',
  instructorPlan: '/instructor/instructor-plans',
  instructorSocialProfiles: '/instructor/instructor-social-profiles',
  instructorLinkedAccounts: '/instructor/instructor-linked-accounts',
  instructorNotification: '/instructor/instructor-notifications',
  instructorIntegrations: '/instructor/instructor-integrations',
  instructorWithdraw: '/instructor/instructor-withdraw',
  instructorWishlist: '/instructor/instructor-withdraw',
  instructorReviews: '/instructor/instructor-withdraw',
  instructorQuizAttempts: '/instructor/instructor-withdraw',
  instructorOrders: '/instructor/instructor-withdraw',
  instructorChat: '/instructor/instructor-withdraw',
  instructorReferral: '/instructor/instructor-withdraw',
  instructorQA: '/instructor/instructor-quiz-questions',
  instructorsettings: '/instructor/instructor-settings',

  studentDashboard: '/student/student-dashboard',
  studentProfile: '/student/student-profile',
  studentsGrid: '/instructor/students',
  studentsDetails: '/instructor/students-details',
  studentsList: '/instructor/student-list',
  studentOrderHistory: '/student/student-order-history',
  studentMessage: '/student/student-messages',
  studentCourses: '/student/student-courses',
  studentLiveEventDetails: '/student/live-event/:id',
  studentCourseContent: '/student/course-content/:id',
  studentCBTInstruction: '/student/cbt-instruction/:id',
  studentCBTTest: '/student/cbt-test/:id',
  studentCBTList: '/student/cbt-list/:id',
  studentCBTReview: '/student/cbt-review/:id',
  studentCertificates: '/student/student-certificates',
  studentReviews: '/student/student-reviews',
  studentWishlist: '/student/student-wishlist',
  studentQuiz: '/student/student-quiz',
  studentQuizQuestion: '/student/student-quiz-questions',
  studentReferral: '/student/student-referral',
  studentTickets: '/student/student-tickets',
  studentSettings: '/student/student-settings',
  studentChangePassword: '/student/student-change-password',
  studentSocialProfile: '/student/student-social-profile',
  studentLinkedAccounts: '/student/student-linked-accounts',
  studentNotification: '/student/student-notifications',
  studentBillingAddress: '/student/student-billing-address',

  cart: '/cart',
  login: '/login',
  register: '/register',
  forgotpassword: '/forgot-password',
  setpassowrd: '/set-password',
  otp: '/otp',
  emailVerification: '/email-verification',
  lockscreen: '/lock-screen',
  privacyPolicy: '/pages/privacy-policy',
  termsConditions: '/terms-conditions',
  contactUs: 'pages/contact-us',
  about_us: '/pages/about-us',
  invoices: '/pages/invoices',
  publicCertificate: '/certificate/:certificateNumber',
  publicCertificateQuery: '/certificate',
  verifyCertificate: '/verify-certificate',
  FAQ: '/pages/faq',
  pricingPlan: '/pages/pricing-plan',
  Error404: '/pages/error-404',
  Error500: '/pages/error-500',
  underconstruction: '/pages/under-construction',
  comingSoon: '/pages/coming-soon',
  becomeAnInstructor: '/pages/become-an-instructor',
  instructorList: '/pages/instructor-list',
  instructorGrid: '/pages/instructor-grid',
  instructorDetails: '/pages/instructor-details',
  notification: '/pages/notifications',
  testimonials: '/pages/testimonials',

  blogGrid: '/blog/blog-grid',
  blogGrid2: '/blog/blog-2-grid',
  blogGrid3: '/blog/blog-3-grid',
  blogDetails: '/blog/blog-details',
  blogCarousal: '/blog/blog-carousal',
  blogMasonry: '/blog/blog-masonry',
  blogLeftSidebar: '/blog/blog-left-sidebar',
  blogRightSidebar: '/blog/blog-right-sidebar',
  blogDetailsLeftSidebar: '/blog/blog-details-left-sidebar',
  blogDetailsRightSidebar: '/blog/blog-details-right-sidebar',

  // Development Routes (Dev Mode Only)
  devCertificateDemo: '/dev/certificate-demo',
  devCertificateTest: '/dev/certificate-test',
  devCertificateManagement: '/dev/certificate-management',
  devCertificateEditor: '/dev/certificate-editor',
  devCertificateExamples: '/dev/certificate-examples',
  devCertificateBlanko: '/dev/certificate-blanko',
}
